import { Query } from "@tanstack/react-query";
import { MatchingStatus } from "PFCore/types/matching_status";

const FINAL_STATUSES = [MatchingStatus.Ready, MatchingStatus.ActivityClosed];

type MatchingQueryData = {
  meta?: {
    status?: MatchingStatus;
  };
};

type UseMatchingRequestParams = {
  maxAttempts?: number;
  delayPerAttempt?: number;
};

export const useMatchingRequestRefetch = <TQueryData = unknown, TError = unknown>({
  maxAttempts = 12,
  delayPerAttempt = 500
}: UseMatchingRequestParams = {}) => {
  const getRefetchInterval = (query: Query<TQueryData & MatchingQueryData, TError>): number | false => {
    if (query?.state?.dataUpdateCount > maxAttempts) {
      return false;
    }

    const status = query.state?.data?.meta?.status;
    if (status && FINAL_STATUSES.includes(status)) {
      return false;
    }

    return maxAttempts * delayPerAttempt;
  };

  return getRefetchInterval;
};
